<template>
    <div class="task-release--add-sync-next">
      <div class="content">
        <vxe-table class='atb-table header-table edit-table' border='full' height='100%' auto-resize resizable
          :data="yearTableData" ref="yearTable" :row-class-name="setRowClass" :spanMethod="mergeMethod" row-key="id"
          :tree-config="{indent: 0, iconOpen: 'icon-arrow-up-bold', iconClose: 'icon-arrow-down-bold-copy', expandAll: true, }"
          :radio-config="{visibleMethod: radioVisible}"
        >
          <vxe-table-column field="tree" width='0' max-width="0" tree-node>
            <template #default="{row}">
              <div v-if="row.isClassifyRow" class='row-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                <div class="classify-wrap">
                  <span class="classify-name">{{ row.classifyName }}</span>
                </div>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column type='radio' width='40' align='center'></vxe-table-column>
          <vxe-table-column field="workItemCategory" width="120" title="类别"></vxe-table-column>
          <vxe-table-column field="workItemContent" width="120" title="工作项目"></vxe-table-column>
          <vxe-table-column field="fullTarget" title="总目标"></vxe-table-column>
          <vxe-table-column field="startDate" width="120" title="开始时间">
            <template #default="{ row }">{{ formatDate(row.startDate, 'yyyy-MM-dd') }}</template>
          </vxe-table-column>
          <vxe-table-column field="finishDate" width="120" title="最终完成时间">
            <template #default="{ row }">{{ formatDate(row.finishDate, 'yyyy-MM-dd') }}</template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div class="form-wrap">
        <el-form :model="editForm" :rules="rules" ref="form" label-width='100px' class="atb-input" label-position="right">
          <el-row>
            <el-col :span="14">    
              <el-form-item label="指定人" prop="wkNos" v-if="isBatch" class="select-form-item">
                <el-select 
                  v-model="editForm.wkNos" ref="selecter"
                  multiple :collapse-tags="isCollapse"
                  disabled max-height="200"
                  :placeholder="placeholder" class="multiple-person-select" clearable :popper-append-to-body="appendBody"
                >
                  <el-option v-for="item in initWkList" :label="item.wkName" :value="item.wkNo" :key="item.wkNo"></el-option>
                </el-select>
                <el-button class="select-btn" type="primary" @click="showUserSelect" style="width: 56px;margin-left: 8px;padding: 12px 4px;">选择</el-button>
              </el-form-item>
              <el-form-item v-else label="指定人" prop="resWkNo" label-width="75px">
                <selecter v-model="editForm.resWkNo" @selecterData="getSelecterData"></selecter>
              </el-form-item>
            </el-col>
            <el-col :span="10">    
              <el-form-item label="权重" prop="weight" label-width="60px">
                <el-autocomplete v-model="editForm.weight" :fetch-suggestions="querySearchWeight" placeholder="权重" @input="handleInputChange" clearable></el-autocomplete>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="btn-wrap">
          <el-button type="save" class="btn" @click="save">保存</el-button>
          <el-button type="saveAndRelease" class="btn" @click="saveAndRelease">发布</el-button>
          <el-button type="clear" class="btn" @click="$parent.$parent.hide()">关闭</el-button>
      </div>
      <common-dialog ref="commonDialog" :title="dialogContent.title" :width="dialogContent.width" :showClose="true" :appendBody="true">
        <template slot="content">
          <component v-bind:is="dialogContent.componentName" :users="userData" :editData="editData" @updateUsers="updateUsers"></component>
        </template>
      </common-dialog>
    </div>
</template>
<script>
import editMixin from '@/mixins/edit.mixin'
import XEUtils from 'xe-utils'
export default {
  name: 'AddSync',
  components: {
    selecter:()=>import('@/component/global/customerSelect'),
    UserSelectDialog:()=>import('@/component/global/UserSelectDialog'),
  },
  mixins: [ editMixin ],
  props: {
    // 编辑信息
    editData: {
      type: Object,
      default: () => {}
    },
    isBatch: Boolean,
    isCollapse: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      id: 'id',
      editForm: {},
      weightList: [],
      rules: {
        weight: [
          { required: true, message: '请选择权重', trigger: 'change' }
        ],
        resWkNo: [
          { required: true, message: '请选择指定人', trigger: 'change' },
        ],
        wkNos: [
          { required: true, message: '请选择指定人', trigger: 'change' },
        ],
      },
      checked: false,
      assignData: [],
      tableColumn: [],
      yearTableData: [],

      userData: [],
      initWkList: [],
      dialogContent: {},
    }
  },
  computed: {
    tableColumnLength() {
      return this.tableColumn.filter(val => val.visible !== false).length;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.tableColumn = this.$refs.yearTable.getColumns();
    })
    this.getYearWorkList();
    this.getWeightDict();

    this.$nextTick(() => {
      this.$refs.form.clearValidate();
    })
  },
  methods:{
    querySearchWeight(queryString, cb) {
      let weightList = this.weightList;
      // 调用 callback 返回建议列表的数据
      cb(weightList);
    },

    getYearWorkList() {
      this.$ajax.get(this.$api.year.yearWorkDetail.list, { year: 1 }).then((res) => {
        const classifyMap = {};
        const classifyRows = [];
        const oldClassifys = [
          { classifyName: "重要KPI", type: 1, workClassify: 0 },
          { classifyName: "业务工作", type: 1, workClassify: 10 },
          { classifyName: "费效管理", type: 1, workClassify: 20 },
          { classifyName: "个人成长", type: 1, workClassify: 50 },
          { classifyName: "其他新增工作", type: 2, workClassify: 60 },
        ];
        const rows = res.data ? res.data.details || [] : [];
        const classifys = res.data.classifys || [];
        const classifyConfigs = classifys.length > 0 ? classifys : oldClassifys;
        classifyConfigs.forEach(classifyItem => {
          if (![1, 2].includes(classifyItem.type)) return false;
          classifyMap[classifyItem.workClassify] = classifyItem;
          const classifyRow = {
            ...classifyItem,
            parentId: null,
            isClassifyRow: true,
            children: [],
          };
          const childs = rows.filter(row => row.workClassify === classifyItem.workClassify);
          childs.forEach(child => {
            child.expandRowContentFlag = false;
            child.parentId = classifyItem.id;
            child.type = classifyItem.type;
          })
          classifyRow.children = childs || [];
          classifyRows.push(classifyRow);
        });
        this.yearTableData = classifyRows;
      });
    },
    formatDate(value, format) {
      return XEUtils.toDateString(value, format)
    },
    setRowClass({ row }) {
      if (row.isClassifyRow) {
        return 'classify-row';
      }
    },
    mergeMethod({row}) {
      if (row.isClassifyRow) {
        return {rowspan: 1, colspan: this.tableColumnLength}
      } else{
        return {rowspan: 1, colspan: 1}
      }
    },
    radioVisible({row}) {
      // 已提交、分类的行不可勾选
      return !row.isClassifyRow;
    },
    save() {
      //通过后提交数据
      let record = this.$refs.yearTable.getRadioRecord();
      if (!record) {
        return this.$message.error('请勾选表格内的工作项');
      }
      if (record) {
        if (!record.workItemContent || !record.fullTarget || !record.startDate || !record.finishDate) {
          return this.$message.error('计划内容填写不完整，工作项目、总目标、开始时间、最终完成时间均不能为空');
        }
        this.$refs["form"].validate(valid => {
          //通过后提交数据
          if (valid) {
            const params = {};
            params.workItemCategory = record.workItemCategory;
            params.workItemContent = record.workItemContent;
            params.workClassify = record.workClassify;
            params.fullTarget = record.fullTarget;
            params.finishFullTarget = record.fullTarget;
            params.startDate = record.startDate;
            params.finishDate = record.finishDate;
            params.weight = this.editForm.weight;
            let apiStr = this.$api.add.PublishYearWork.adu;
            if (this.isBatch) {
              apiStr = this.$api.add.PublishYearWork.batchAdd;
              params.detailResWkInfos = this.editForm.resWks;
            } else {
              const resWkObj = this.assignData.find(t => t.jobNo === this.editForm.resWkNo);
              params.detailResWkInfos = [{
                resWkName: resWkObj ? resWkObj.name : '',
                resWkNo: this.editForm.resWkNo,
              }];
              params.resWkName = resWkObj.name;
              params.resWkNo = this.editForm.resWkNo;
            }
            params.source = 3;
            params.sourceId = record.id;
            this.$ajax.post(apiStr, params).then(res => {
              if (res.code === 0) {
                this.$refs.form.resetFields();
                this.$message.success('保存成功');
                this.$emit('submitSuccess');
                this.editForm = {};
                if (!this.checked)
                  this.$parent.$parent.hide();
              }
            });
          }
        });
      }
    },
    saveAndRelease() {
      const record = this.$refs.yearTable.getRadioRecord();
      if (!record) {
        return this.$message.error('请勾选表格内的工作项');
      }
      if (record) {
        if (!record.workItemContent || !record.fullTarget || !record.startDate || !record.finishDate) {
          return this.$message.error('计划内容填写不完整，工作项目、总目标、开始时间、最终完成时间均不能为空');
        }
        this.$refs["form"].validate(valid => {
          //通过后提交数据
          if (valid) {
            const params = {};
            params.workItemCategory = record.workItemCategory;
            params.workItemContent = record.workItemContent;
            params.workClassify = record.workClassify;
            params.fullTarget = record.fullTarget;
            params.finishFullTarget = record.fullTarget;
            params.startDate = record.startDate;
            params.finishDate = record.finishDate;
            params.weight = this.editForm.weight;
            let apiStr = this.$api.add.PublishYearWork.saveAndRelease;
            if (this.isBatch) {
              apiStr = this.$api.add.PublishYearWork.batchSaveAndRelease;
              params.detailResWkInfos = this.editForm.resWks;
            } else {
              const resWkObj = this.assignData.find(t => t.jobNo === this.editForm.resWkNo);
              params.detailResWkInfos = [{
                resWkName: resWkObj ? resWkObj.name : '',
                resWkNo: this.editForm.resWkNo,
              }];
              params.resWkName = resWkObj.name;
              params.resWkNo = this.editForm.resWkNo;
            }
            params.source = 3;
            params.sourceId = record.id;
            this.$ajax.put(apiStr, params).then(res => {
              if (res.code === 0) {
                this.$refs.form.resetFields();
                this.$message.success('发布成功');
                this.$emit('submitSuccess');
                this.editForm = {};
                if(!this.checked) this.$parent.$parent.hide();
                if(this.isBatch) this.$router.push('/manage/export-task/index')
              }
            });
          }
        });
      }
    },
    getSelecterData(data){
      this.assignData = data;
    },
    getWeightDict() {
      this.$ajax.get(this.$api.common.getDict, { ItemType: 'WorkWeight' }).then((res) => {
        if (res.code === 0) {
          this.weightList = [];
          res.data.rows.forEach(t => {
            this.weightList.push({ value: eval(t.itemValue) });
          });
        }
      });
    },
    handleInputChange(value) {
      value = value + '';
      value = value.trim();
      // 只能输入数字
      value = value.replace(/[^\d]/g, '')
      if (value) {
        value = parseInt(value);
        if (value < 1) value = 1;
        if (value > 100) value = 100;
      }
      this.editForm.weight = value;
    },
    showUserSelect() {
      this.userData = JSON.parse(JSON.stringify(this.initWkList));
      this.dialogContent = {
        title: '人员',
        componentName: 'UserSelectDialog',
        width: '720px'
      }
      this.$refs.commonDialog.show()
    },
    updateUsers(list) {
      this.initWkList = list;
      this.editForm.wkNos = this.initWkList.map(item => item.wkNo);
      this.editForm.resWks = this.initWkList.map(item => {
        return {
          resWkName: item.wkName,
          resWkNo: item.wkNo,
        }
      });
    }
  },
}
</script>
<style scoped lang='scss'>
  .task-release--add-sync-next {
    .content {
      height: 450px;
    }
    .el-button.el-button--save {
        color: #ffffff;
        background-color: #22b6a1;
        border-color: #22b6a1;
    }
    .el-button.el-button--saveAndRelease {
        background-color: #0dcc82;
        border-color: #0dcc82;
        color: #ffffff;
    }
    .el-button.el-button--clear {
        background-color: #F5BF2B;
        border-color: #F5BF2B;
        color: #ffffff;
    }
    .el-button {
        width: 110px;
        border-radius: 10px;
    }
    .btn-wrap{
         text-align: right;
         margin-top: 10px;
    }
    .form-wrap{
        margin: 10px 0px;
        .el-autocomplete{
            width: 100%;
        }
        .customerSelect{
            width: 100%;
        }
    }
    ::v-deep .header-table {
      overflow: auto;
      flex-grow: 1;
      .vxe-table--header-wrapper {
        background-color: $--bg-color-complete !important;
      }
    }
    
    ::v-deep .classify-row {
      padding-left: 8px;
      background-color: $--color-bg-table-header;
      .vxe-cell--placeholder {
        font-size: 0;
      }
      .vxe-cell--checkbox, .vxe-cell {
        padding: 0;
      }
      .vxe-body--column {
        background-image: linear-gradient(#fff, #fff), linear-gradient(#fff, #fff)
      }
    }
    .classify-name {
      color: $--color-primary;
      user-select: none;
    }
    .vxe-tree-cell {
      padding: 0;
    }
    ::v-deep .vxe-tree--btn-wrapper {
      display: none;
      left: 8px;
      top: 42%;
    }
  }
</style>
<style lang="scss">
  .multiple-person-select .el-input__suffix {
    display: none;
  }
</style>